module.exports = __webpack_public_path__ + "static/northgate-hero-493815f1c550a70453cce7f42a754f5e.mp4";